import { useContext } from 'react'
import { navigate } from 'gatsby'

import { useTranslation } from '@models/Translation'
import { StoreContext } from '@models/Store'

import * as style from './style.module.sass'

type LanguageSwitchProps = {
  design?: 'white' | 'black'
}
const LanguageSwitch = ({ design = 'black' }: LanguageSwitchProps) => {
  const { action } = useContext(StoreContext)
  const { locale, path } = useTranslation()
  const location = typeof window !== 'undefined' ? window.location : undefined
  const linkPath =
    `${locale === 'ja' ? '/en' : ''}${path}`.replace(/(.+)\/$/, '$1') +
    location?.search

  const onClick = () => {
    action.setVoiceArticleIds([])
    action.reload()
    // intlのchangeLocaleを利用すると日本語に変更した場合に `/ja` が付与されてしまうので、gatsbyのnavigateを利用
    navigate(linkPath)
  }

  return (
    <div className={style.language} data-design={design}>
      <button data-locale={locale} onClick={onClick} disabled={locale === 'ja'}>
        JP
      </button>
      <button data-locale={locale} onClick={onClick} disabled={locale === 'en'}>
        EN
      </button>
    </div>
  )
}

export default LanguageSwitch
